import React from "react";
import { Row, Col, Container } from "shards-react";
import styled from "styled-components";

import ContactForm from "shared/components/ContactForm/ContactForm";
import contactimg from "shared/assets/img/contact.jpeg";
import { useTranslation } from "react-i18next";
import Layout from "shared/container/Layout";

const ContactContent = styled.div`
  padding: 30px 70px;
  color: #fff;
  border-radius: 6px;
  background-image: url(${contactimg});
  margin-left: -15px;
  margin-right: -15px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: calc(100vh - 60px);
`;
const ContactImage = styled.div`
  padding: 20px 60px;
`;
const Contact = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout>
    <ContactContent className="bg-blue">
      <Container>
        <Row>
          <Col className="mt-5 text-center">
            <div className="mb-4">
              <h3 style={{color:"#fff"}}>{t("common:contact.ContactUs")}</h3>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm="12" lg="6">
            <ContactImage>
              <img
                className="mr-2 mb-3"
                style={{ width: "100%", height: "auto" }}
                src={require("shared/assets/img/contact_page.png")}
                alt="th"
              />
            </ContactImage>
            <div className="text-center">
              <div>{t("common:contact.Office")}</div>
              <div>
              {t("common:contact.Addrass")}
              </div>
              <div>{t("common:contact.Phone")}</div>
              <div>Email : logistic@nesdc.go.th</div>
            </div>
          </Col>
          <Col sm="12" lg="6" style={{paddingTop:30}}>
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </ContactContent>
    </Layout>
  );
};
export default Contact;
